import { BaseModel } from "./base.model";

export class CustomerModel extends BaseModel {
    customerCode: string;
    firstName: string;
    lastName: string;
    mobileNo: string;
    email: string;
    address: string;
    country: string;
    birthdayDate: string;
    creditAmt: number;
    totalCount: number;
    panCardNo: string;
    createdOn: string;
    altMobileNo: string;
}


export interface ProductHeaderModel extends BaseModel {
    invoiceNo: string;
    categoryId: number;
    styleNo: string;
    metalKT: string;
    metalKTId: number;
    metalColor: string;
    grossWt: number;
    diaWt: number;
    netWt: number;
    diaQty: number;
    qty: number;
    mrp: number;
    diaMrp: number;
    dpPrice: number;
    diamondClarityName: string;
    certificateNo: string;
    huid: string;
    ordNo: string;
    collectionId: number;
    colorStoneWt: number;
    otherWt: number;
    franchiseVariantGoldRate: number;
    customerVariantGoldRate: number;
    goldRateMargin: number;
    franchiseDiaVariantAmount: number;
    customerDiaVariantAmount: number;
    diaMargin: number;
    franchiseLaborVariantAmount: number;
    customerLaborVariantAmount: number;
    laborMargin: number;
    orderType: string;
    bagNo: string;
    orderDate: string;
    overallMargin: number;
    isActive: boolean;
    storeCode: string;
    storeId: number;
    storeName: string;
    isStoreReturn: boolean;
    oldDP: number;
    oldMrp: number;
    inwardDate: string;
    isReceived: boolean;
    materialTypeId: number;
    isSRP: boolean;
    mrpType: string;
    odIdNo: string;
    isSNMCC: boolean;
    goldMrp: number;
    labMrp: number;
    colorStonePrice: number;
    isRepaired: boolean;
    isSpecial: boolean;
    cocd: string;
    deleted: boolean;
    categoryName: string;
    complexityValue: number;
    tag: string;
    purchaseRate: number;
    metalMrp: number;
    sellingPrice: number;
    image: string;
    isShiped: boolean;
    isReceivedInIST: boolean;
    isSameStoreProduct: boolean;
}


export interface InvoiceModel {
    invoiceNo: string;
    invoiceDate: string;
    storeName: string;
    invoiceAmount: number;
    customerMobileNo: string;
    customerName: string;
    customerCode: string;
    invoiceItemDetails: InvoiceItemModel[];
}

export interface InvoiceItemModel {
    diaWt: number;
    netWt: number;
    diaQty: number;
    category: string;
    style: string;
    karat: string;
    huid: string;
    dpPrice: number;
    selingPrice: number;
    isSRP: string;
    complexityName: string;
    complexityPercentage: number;
    materialType: string;
    bagNo: string;
}